// extracted by mini-css-extract-plugin
export default {"container":"Error_container__-QF5S","title":"Error_title__CGYJX"};